import { getForumSectionUrl } from '../services/get-section-url';
import createAction from '../services/create-action';
import { transformWixCodeLocation } from '../store/location/transform-wix-code-location';
import { NAVIGATE } from '../../app/constants/interactions';
import { InteractionController } from '../interactions/interaction-controller';

export const NAVIGATE_WITHIN_FORUM = 'app/NAVIGATE_WITHIN_FORUM';

const navigateWithinForumAction = createAction(NAVIGATE_WITHIN_FORUM);

export const navigateWithinForum =
  (path) =>
  async (dispatch, getState, { wixCodeApi, panoramaClient }) => {
    InteractionController.interactionStarted(NAVIGATE, panoramaClient);

    const sectionUrl = getForumSectionUrl(wixCodeApi);

    // Replace full url with forum relative one
    if (path.startsWith(sectionUrl)) {
      path = path.replace(sectionUrl, '');
    }

    const prevPath = (await transformWixCodeLocation(wixCodeApi, sectionUrl)).pathname;
    dispatch(
      navigateWithinForumAction({
        path,
        prevPath,
      }),
    );

    const pageUrl = wixCodeApi.location.baseUrl;
    const sectionPath = sectionUrl.replace(pageUrl, '');

    return wixCodeApi.location.to(`${sectionPath}${path}`, {
      disableScrollToTop: true,
    });
  };
